import { Component } from 'react'
import { FormattedMessage } from 'react-intl'

export default class ResortPricingRowSoldOut extends Component {
  handleClick = () => {
    this.props.triggerAvailabilityCalendar(true)
  }

  render() {
    const { room, isFixedPackage } = this.props
    return (
      <div className='resort-pricing-row unavailable'>
        <div className='resort-pricing__rooms'>
          <h4 className='room-name'>{ room.title }</h4>
          <div className='room-info'>
            <div className='room-info-wrapper'>
              <a className='room-more-info' onClick={() => this.props.openRoomPopup(room)}>
                <FormattedMessage id='show_room_info' defaultMessage='Show room information' />
                <i className='font-icons right-arrow-icon' />
              </a>
            </div>
          </div>
        </div>
        <div className='resort-pricing__whats-included' />
        <div className='resort-pricing__meal-plan' />
        <div className='resort-pricing__price center-align'>
          <span className='sold-out'>
            <i className='font-icons fail-icon-new' />&nbsp;
            <FormattedMessage id='sold_out' defaultMessage='Sold out' />
          </span>
          { !isFixedPackage ? (
            <button className='btn-red-invert' smooth-scroll='smooth-scroll' scroll-to='#availiability-calendar-wrapper' onClick={this.handleClick}>
              <FormattedMessage id='view_availability' defaultMessage='View availability calendar' />
            </button>
          ) : ''}
        </div>
      </div>
    )
  }
}
